import { render, staticRenderFns } from "./veJkyProjectWorkEdit.vue?vue&type=template&id=52f1e392&scoped=true"
import script from "./veJkyProjectWorkEdit.vue?vue&type=script&lang=js"
export * from "./veJkyProjectWorkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f1e392",
  null
  
)

export default component.exports